const salidasDelDia = {
    ObtenerCedulasParaSalidas: 'SINOJ/SalidasDelDia/ObtenerCedulasParaSalidas',
    ObtenerSalidasDeNotificador: 'SINOJ/SalidasDelDia/ObtenerSalidasDeNotificador',
    GuardarNuevaSalida: 'SINOJ/SalidasDelDia/GuardarNuevaSalida',
    GuardarNuevaConstitucion: 'SINOJ/SalidasDelDia/GuardarNuevaConstitucion',
    EliminarObservacionesDeAbogado: 'SINOJ/SalidasDelDia/EliminarObservacionesDeAbogado',
    ObtenerDatosDeNotificador: 'SINOJ/SalidasDelDia/ObtenerDatosDeNotificador',
    ObtenerConstitucionesSalidaDeNotificador: 'SINOJ/SalidasDelDia/ObtenerConstitucionesSalidaDeNotificador',
    GuardarAnexosDeConstitucion: 'SINOJ/SalidasDelDia/GuardarAnexosDeConstitucion'
}

const resultado = {
    ObtenerCedulasParaResultado: 'SINOJ/Resultado/ObtenerCedulasParaResultado',
    GuardarResultadoDeCedula: 'SINOJ/Resultado/GuardarResultadoDeCedula',
    ObtenerDatosDeNotificador: 'SINOJ/Resultado/ObtenerDatosDeNotificador',
    ObtenerResultadosSinDocumento: 'SINOJ/Resultado/ObtenerResultadosSinDocumento',
    GuardarResultadoDeCitatorio: 'SINOJ/Resultado/GuardarResultadoDeCitatorio',
    ActualizarDocumento: 'SINOJ/Resultado/ActualizarDocumento'
}

const notificaciones = {
    salidasDelDia: salidasDelDia,
    resultado: resultado
}
  
export default notificaciones;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sistema/Notificaciones/Notificaciones.js
// module id = null
// module chunks = 